import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Instagram, Mail, ArrowUp } from 'lucide-react';

const footerLinks = [
  {
    title: 'Quick Links',
    links: [
      { name: 'About Us', href: '#about' },
      { name: 'Products', href: '#products' },
      { name: 'Capabilities', href: '#capabilities' },
      { name: 'Contact', href: '#contact' },
    ],
  },
  {
    title: 'Products',
    links: [
      { name: "Girls' Wear", href: '#products' },
      { name: "Boys' Wear", href: '#products' },
      { name: 'Baby Wear', href: '#products' },
      { name: 'Ladieswear', href: '#products' },
    ],
  },
  {
    title: 'Certifications',
    links: [
      { name: 'SEDEX', href: '#certifications' },
      { name: 'GOTS', href: '#certifications' },
      { name: 'Oeko-Tex', href: '#certifications' },
      { name: 'BCI', href: '#certifications' },
    ],
  },
];

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer 
      data-testid="footer"
      className="bg-slate-900 text-white"
    >
      {/* Main Footer */}
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-2">
                <img 
                  src="https://customer-assets.emergentagent.com/job_981a21ab-2b01-463f-b2b0-9581b9124d66/artifacts/5h3iwfl2_Strawberry%20Logo%20NEW.jpg"
                  alt="Studio Exports Pvt. Ltd."
                  className="h-12 w-auto object-contain rounded"
                />
              </div>
            </div>
            <p className="font-sans text-sm text-white/60 leading-relaxed mb-6 max-w-sm">
              Leading manufacturer and exporter of children's wear and ladies' wear, 
              serving global fashion brands since 1996.
            </p>
            {/* Social Links */}
            <div className="flex gap-4">
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-rose-700 transition-colors duration-300"
                data-testid="social-linkedin"
              >
                <Linkedin size={18} strokeWidth={1.5} />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-rose-700 transition-colors duration-300"
                data-testid="social-instagram"
              >
                <Instagram size={18} strokeWidth={1.5} />
              </a>
              <a 
                href="mailto:info@strawberrystudio.com" 
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-rose-700 transition-colors duration-300"
                data-testid="social-email"
              >
                <Mail size={18} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Link Columns */}
          {footerLinks.map((column, index) => (
            <div key={index}>
              <h4 className="font-sans text-xs font-medium tracking-[0.2em] uppercase text-white/40 mb-6">
                {column.title}
              </h4>
              <ul className="space-y-4">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="font-sans text-sm text-white/70 hover:text-white transition-colors duration-300"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Large Brand Text */}
      <div className="border-t border-white/10 py-16 md:py-24 overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="text-center"
        >
          <h2 className="font-serif footer-text font-medium text-white/5 whitespace-nowrap">
            Strawberry Studio
          </h2>
        </motion.div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 py-6">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="font-sans text-xs text-white/40">
              © {new Date().getFullYear()} Strawberry Studio Exports Pvt. Ltd. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="font-sans text-xs text-white/40">
                Noida, India • Bangalore, India
              </span>
              <button
                onClick={scrollToTop}
                data-testid="scroll-to-top-btn"
                className="w-10 h-10 bg-white/10 flex items-center justify-center hover:bg-rose-700 transition-colors duration-300"
              >
                <ArrowUp size={18} strokeWidth={1.5} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
